import React from 'react';

const ShareSidebar = ({ title, url }) => {
  return (
    <div className="blogShare">
      <ul className="blogShare__items">
        <li className="blogShare__item">
          <a
            href={`https://twitter.com/intent/tweet?url=${url}&via=rippling&text=${title}`}
            rel="noreferrer noopener"
            target="_blank"
            title="Share on Twitter"
          >
            <svg
              fill="none"
              height="42"
              viewBox="0 0 42 42"
              width="42"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21Z"
                stroke="#DDDBD6"
                strokeWidth="1"
              />
              <path
                d="M28.3484 18.0396C27.7981 18.2539 27.2142 18.3944 26.6164 18.4564C27.2467 18.1256 27.7185 17.6046 27.944 16.9905C27.3512 17.2995 26.7026 17.5169 26.0263 17.6334C25.5717 17.2081 24.9703 16.9263 24.3152 16.8319C23.66 16.7374 22.9877 16.8355 22.4024 17.111C21.8171 17.3864 21.3515 17.8239 21.0776 18.3555C20.8038 18.8872 20.7371 19.4834 20.8877 20.0518C19.6887 19.999 18.5158 19.7251 17.445 19.2479C16.3743 18.7706 15.4297 18.1007 14.6727 17.2817C14.2869 17.8653 14.1686 18.5562 14.3419 19.2137C14.5152 19.8713 14.967 20.4461 15.6054 20.8211C15.1264 20.8082 14.658 20.6944 14.2394 20.4893C14.2394 20.5008 14.2394 20.5116 14.2394 20.523C14.2395 21.1351 14.4804 21.7283 14.9213 22.2021C15.3622 22.6758 15.9759 23.0009 16.6583 23.1222C16.2144 23.2283 15.7487 23.244 15.2968 23.1682C15.4897 23.6945 15.8649 24.1546 16.3699 24.4843C16.8748 24.8141 17.4843 24.9969 18.1132 25.0073C16.848 25.8767 15.2432 26.2714 13.6484 26.1053C14.9444 26.8355 16.4401 27.2455 17.9785 27.2924C19.517 27.3392 21.0413 27.0211 22.3917 26.3715C23.7421 25.7219 24.8686 24.7647 25.653 23.6004C26.4375 22.4361 26.851 21.1077 26.85 19.7545C26.85 19.6395 26.85 19.5246 26.8413 19.412C27.4317 19.0372 27.9412 18.5726 28.3458 18.0403L28.3484 18.0396Z"
                fill="black"
              />
            </svg>

            <span className="blogShare__text">Tweet</span>
          </a>
        </li>

        <li className="blogShare__item">
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            rel="noreferrer noopener"
            target="_blank"
            title="Share on Facebook"
          >
            <svg
              fill="none"
              height="42"
              viewBox="0 0 42 42"
              width="42"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21Z"
                stroke="#DDDBD6"
                strokeWidth="1"
              />
              <path
                d="M23.8498 20.9885H21.6696V28.3484H18.3677V20.9885H16.7969V18.4019H18.3677V16.7286C18.3322 16.317 18.394 15.9033 18.5489 15.5159C18.7038 15.1285 18.948 14.7766 19.2647 14.4847C19.5814 14.1927 19.9631 13.9675 20.3834 13.8247C20.8037 13.6819 21.2526 13.6248 21.6991 13.6573L24.1469 13.6667V16.1755H22.3744C22.2755 16.1712 22.1769 16.1871 22.0854 16.2219C21.994 16.2566 21.9119 16.3095 21.8451 16.3768C21.7783 16.444 21.7283 16.5239 21.6987 16.611C21.6691 16.698 21.6606 16.7899 21.6738 16.8803V18.4027H24.1418L23.8498 20.9885Z"
                fill="black"
              />
            </svg>

            <span className="blogShare__text">Facebook</span>
          </a>
        </li>

        <li className="blogShare__item">
          <a
            href={`http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`}
            rel="noreferrer noopener"
            target="_blank"
            title="Share on LinkedIn"
          >
            <svg
              fill="none"
              height="42"
              viewBox="0 0 42 42"
              width="42"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21Z"
                stroke="#DDDBD6"
                strokeWidth="1"
              />
              <path
                d="M28.3484 22.0164V27.2984H25.1735V22.3705C25.1735 21.1312 24.714 20.2885 23.5635 20.2885C23.2051 20.2905 22.8561 20.3992 22.5643 20.5996C22.2724 20.8001 22.0521 21.0825 21.9333 21.4083C21.8516 21.6488 21.8158 21.9017 21.8276 22.1545V27.2984H18.6481C18.6481 27.2984 18.6903 18.9527 18.6481 18.0923H21.8239V19.3971C21.8175 19.4077 21.8083 19.4174 21.8028 19.4272H21.8239V19.3971C22.1116 18.9155 22.5308 18.519 23.0359 18.2507C23.5411 17.9825 24.1129 17.8527 24.6892 17.8754C26.7807 17.8754 28.3484 19.1917 28.3484 22.02V22.0164ZM15.3233 13.6486C14.8846 13.6433 14.4617 13.8061 14.1477 14.1012C13.8336 14.3962 13.6541 14.7994 13.6486 15.222C13.6431 15.6446 13.8121 16.052 14.1184 16.3545C14.4247 16.6571 14.8433 16.83 15.282 16.8353H15.2994C15.5167 16.8366 15.732 16.7968 15.9332 16.7179C16.1345 16.6391 16.3176 16.5228 16.4722 16.3758C16.6267 16.2288 16.7497 16.0539 16.8342 15.8611C16.9186 15.6683 16.9627 15.4614 16.9641 15.2521C16.9655 15.0429 16.9241 14.8354 16.8422 14.6416C16.7604 14.4478 16.6397 14.2714 16.4871 14.1224C16.3345 13.9735 16.1529 13.8551 15.9528 13.7737C15.7526 13.6924 15.5378 13.6499 15.3206 13.6486H15.3233ZM13.7134 27.2976H16.8911V18.0914H13.7134V27.2976Z"
                fill="black"
              />
            </svg>

            <span className="blogShare__text">LinkedIn</span>
          </a>
        </li>

        <li className="blogShare__item">
          <a
            href={`mailto:?subject=${title}&body=${url}`}
            rel="noreferrer noopener"
            target="_blank"
            title="Share this article via email"
          >
            <svg
              fill="none"
              height="42"
              viewBox="0 0 42 42"
              width="42"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21Z"
                stroke="#DDDBD6"
                strokeWidth="1"
              />
              <path
                clipRule="evenodd"
                d="M15.1184 15.5742H26.8784C27.6869 15.5742 28.3484 16.2357 28.3484 17.0442V25.8642C28.3484 26.6727 27.6869 27.3342 26.8784 27.3342H15.1184C14.3099 27.3342 13.6484 26.6727 13.6484 25.8642V17.0442C13.6484 16.2357 14.3099 15.5742 15.1184 15.5742ZM21.7802 21.7026L26.5871 18.6965C26.7708 18.5789 26.8811 18.3804 26.8811 18.1673C26.8811 17.6748 26.3445 17.3808 25.9256 17.6381L21.0011 20.7177L16.0766 17.6381C15.6576 17.3808 15.1211 17.6748 15.1211 18.1673C15.1211 18.3804 15.2313 18.5789 15.4151 18.6965L20.222 21.7026C20.6997 22.004 21.3024 22.004 21.7802 21.7026Z"
                fill="black"
                fillRule="evenodd"
              />
            </svg>

            <span className="blogShare__text">Mail</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ShareSidebar;
